lmApp
  .controller('CatchupController', ['$scope', '$rootScope', '$q', '$timeout', '$routeParams', '$location', '$templateCache', '$compile', 'ToastService', 'ModalWindowService', 'EpgService', 'AssetService', 'AssetResource', 'LiveEventResource',
    function ($scope, $rootScope, $q, $timeout, $routeParams, $location, $templateCache, $compile, ToastService, ModalWindowService, EpgService, AssetService, AssetResource, LiveEventResource) {
      $scope.loading = false;
      $scope.channels = [];
      $scope.currentChannel = -1;

      var processChannel = function(asset) {
        var processed = {
          id: asset.id,
          name: asset.name,
          epg: {
            id: 0,
            name: ''
          },
          catchupDepth: 0,
          streamHLS: false,
          streamDASH: false,
          streamHLSId: 0,
          streamDASHId: 0,
          recorded: -1
        };
        if (asset.epg) {
          processed.epg.id = asset.epg.id;
          processed.epg.name = asset.epg.ext_id;
        }
        var catchupResources = asset.resources.filter(function(resource) {
          return resource.category === 'catchup';
        });
        if (catchupResources.length > 0) {
          processed.catchupDepth = Math.round(catchupResources[0].catchup_depth/3600) || 0;
        }

        var streamHLSResources = asset.resources.filter(function(resource) {
          return resource.type === 'hls-live' && resource.state === 'deployed';
        });
        if (streamHLSResources.length > 0) {
          processed.streamHLS = true;
          processed.streamHLSId = streamHLSResources[0].id;
        }

        var streamDashResources = asset.resources.filter(function(resource) {
          return resource.type === 'dash-live' && resource.state === 'deployed';
        });
        if (streamDashResources.length > 0) {
          processed.streamDASH = true;
          processed.streamDASHId = streamDashResources[0].id;
        }

        return processed;
      };

      var recordStat = function() {
        var params = {};
        params['catchup[eq]'] = '1';

        var liveMap = {};
        var keys = {};

        var getRecords = function(offset) {
          params['$limit'] = 3000;
          params['$offset'] = offset;
          LiveEventResource.get(params).$promise
              .then(function (records) {
                if (records.length > 0) {
                  for (var i = 0; i < records.length; i++) {
                    if (!liveMap.hasOwnProperty(records[i].live_id)) {
                      liveMap[records[i].live_id] = 0;
                    }
                    var key = records[i].live_id + records[i].end_time + records[i].start_time;
                    if (keys.hasOwnProperty(key)) {
                      continue
                    }
                    var played = moment(records[i].end_time).diff(moment(records[i].start_time), 'seconds');
                    liveMap[records[i].live_id] += played;
                    keys[key] = true;
                  }

                  offset += 3000;
                  getRecords(offset);
                } else {
                  keys = {};
                  angular.forEach($scope.channels, function(ch) {
                    if (liveMap.hasOwnProperty(ch.id)) {
                      ch.recorded = Math.round(liveMap[ch.id]/3600) || 0;
                    } else {
                      ch.recorded = 0;
                    }
                  });
                  liveMap = {};
                }
              })
              .catch(function (reason) {
                $rootScope.debugInfo(reason, 'silent');
              })
        };

        LiveEventResource.count(params).$promise
            .then(function (result) {
              var count = result.data;
              if (count === 0) {
                return;
              }
              getRecords(0);
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason, 'silent');
            })
      };

      $scope.getChannels = function () {
        if ($scope.loading) return;
        $scope.loading = true;
        $rootScope.showLinearProgress('#catchupLoader');

        var params = {};
        params['type[in]'] = 'channel';
        params['$expand'] = 'resources(url),epg';

        AssetResource.get(params).$promise
          .then(function (assets) {
              var processed = assets.filter(function(asset) {
                if (asset.resources) {
                  var catchupResources = asset.resources.filter(function(resource) {
                    return resource.category === 'catchup' && resource.state === 'deployed';
                  });
                  if (catchupResources.length > 0) {
                    return true;
                  }
                }
                return false;
              });
              $scope.channels = processed.map(function(asset) {
                return processChannel(asset);
              });
              $scope.loading = false;
              $rootScope.hideLinearProgress('#catchupLoader');
              recordStat();
          })
          .catch(function (reason) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#catchupLoader');
              ToastService.Small({
                title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                color: 'amber',
                icon: 'server-off',
                blocked: true
              }, 1000 * 3);
              $rootScope.debugInfo(reason, 'silent');
            })
      };

      $scope.getChannels();

      $scope.date = {};
      $scope.searchEvent = '';
      $scope.searchFiel = '';

      var processLiveEvent = function(liveEvent) {
        var processed = {
          id: liveEvent.id,
          name: liveEvent.name,
          description: liveEvent.description,
          startTime: moment(liveEvent.start_time).format('HH:mm'),
          endTime: moment(liveEvent.end_time).format('HH:mm'),
          pictureURL: '',
          catchup: liveEvent.catchup
        };
        if (liveEvent.thumbnail) {
          processed.pictureURL = liveEvent.thumbnail.url;
        }
        return processed;
      };

      $scope.getEvents = function (channel, params) {
        $scope.loading = true;
        $rootScope.showLinearProgress('#catchupLoader' + channel.id);

        channel._Events = [];

        LiveEventResource.get(params).$promise
            .then(function (liveEvents) {
              channel._Events = liveEvents.map(function(le) {
                return processLiveEvent(le);
              });

              $scope.loading = false;
              $rootScope.hideLinearProgress('#catchupLoader' + channel.id);
            })
            .catch(function (reason) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#catchupLoader' + channel.id);
              $rootScope.debugInfo(reason);
            });
      };

      $scope.setActiveChannel = function (channel) {
        if ($scope.currentChannel === channel.id) {
          $scope.currentChannel = -1;
          $location.search('channel_id', null);
          return;
        }

        $scope.currentChannel = channel.id;
        $scope.collapseProgramme();
        if (channel.id !== -1) {
          $location.search('channel_id', channel.id);
        } else {
          $location.search('channel_id', null);
        }

        $scope.selectedStream = '';
        $scope.selectedStreamEscaped = '';
        $scope.selectedStreamError = '';
        $scope.isHLSSupported = channel.streamHLS;
        $scope.hlsResourceId = channel.streamHLSId;

        $scope.getHLSStream = function () {
          if (!$scope.isHLSSupported) return;
          $scope.selectedStreamError = '';
          AssetResource.getStream({ id: channel.id, resourceId: $scope.hlsResourceId }).$promise
              .then(function (response) {
                $scope.selectedStream = response.data;
                $scope.selectedStreamEscaped = escape(response.data);
                $scope.selectedStreamError = '';
              })
              .catch(function (reason) {
                if (reason.data.error) {
                  $scope.selectedStreamError = reason.data.error;
                }
                $rootScope.debugInfo(reason, 'silent');
              })
        };

        $scope.getHLSStream();

        if ($scope.routeDate) {
          $scope.date.currentDate = moment($scope.routeDate * 1000);
        } else {
          $scope.date.currentDate = moment.utc();
          $location.search('date', $scope.date.currentDate.unix());
        }

        var params = {
          'live.id[eq]': channel.id,
          'end_time[gt]': $scope.date.currentDate.startOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z',
          'start_time[lt]': $scope.date.currentDate.endOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z',
          '$expand': 'thumbnail(url)'
        };

        if ($scope.watcher) $scope.watcher();
        $scope.watcher = $scope.$watch('date.currentDate', function (newValue, oldValue) {
          if (newValue !== oldValue) {
            $location.search('date', newValue.unix());
            $scope.collapseProgramme();
            var params = {
              'live.id[eq]': channel.id,
              'end_time[gt]': moment(newValue).startOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z',
              'start_time[lt]': moment(newValue).endOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z',
              '$expand': 'thumbnail(url)'
            };
            $scope.getEvents(channel, params);
          }
        });
        $scope.getEvents(channel, params);
      };

      $scope.isActiveChannel = function (channel) {
        return channel.id === $scope.currentChannel;
      };

      $scope.isActiveEvent = function (event) {
        return $scope.currentProgramm && event.id === $scope.currentProgramm.id;
      };


      $scope.expandProgramme = function (channel, event) {
        if ($scope.currentProgramm.id === event.id) return;

        $scope.currentProgramm = event;
        $scope.currentProgramm.hlsStream = '';
        $scope.currentProgramm.hlsStreamEsc = '';
        $scope.currentProgramm.hlsStreamErr = '';
        $scope.currentProgramm.dashStream = '';
        $scope.currentProgramm.dashStreamErr = '';

        if (!event.catchup) {
          return;
        }
        $rootScope.showLinearProgress('#catchupLoader' + channel.id);

        $scope.license = $location.protocol() + '://'+ $location.host() + '/discovery:80/sdp/v2/assets/'+channel.id+'/wv-license?auth_token='+lh.common.config.get('authToken');

        $scope.getCatchupHLSStream = function () {
          $scope.currentProgramm.hlsStreamErr = '';
          LiveEventResource.getHLSStream({ id: event.id }).$promise
              .then(function (response) {
                $scope.currentProgramm.hlsStream = response.data;
                $scope.currentProgramm.hlsStreamEsc = escape(response.data);
                $rootScope.hideLinearProgress('#catchupLoader' + channel.id);
              })
              .catch(function (reason) {
                $scope.currentProgramm.hlsStream = '';
                $scope.currentProgramm.hlsStreamEsc = '';
                if (reason.data.error) {
                  $scope.currentProgramm.hlsStreamErr = reason.data.error;
                }
                $rootScope.debugInfo(reason, 'silent');
                $rootScope.hideLinearProgress('#catchupLoader' + channel.id);
              })
        };

        $scope.getCatchupDashStream = function () {
          $scope.currentProgramm.dashStreamErr = '';
          LiveEventResource.getDashStream({ id: event.id }).$promise
              .then(function (response) {
                $scope.currentProgramm.dashStream = response.data;
                $rootScope.hideLinearProgress('#catchupLoader' + channel.id);
              })
              .catch(function (reason) {
                $scope.currentProgramm.dashStream = '';
                if (reason.data.error) {
                  $scope.currentProgramm.dashStreamErr = reason.data.error;
                }
                $rootScope.debugInfo(reason, 'silent');
                $rootScope.hideLinearProgress('#catchupLoader' + channel.id);
              })
        };

        $scope.getCatchupHLSStream();
        $scope.getCatchupDashStream();
      };

      $scope.collapseProgramme = function () {
        $scope.currentProgramm = {};
      };

      $scope.routeChannelId = null;
      if ($routeParams.channel_id) {
        $scope.routeChannelId = Number($routeParams.channel_id);
      }

      $scope.routeDate = null;
      if ($routeParams.date) {
        $scope.routeDate = Number($routeParams.date);
      }

      $scope.$on('$routeUpdate', function () {
        if ($scope.routeChannelId && !$routeParams.channel_id) {
          $scope.currentChannel = -1;
          $location.search('date', null);
        }
        $scope.routeChannelId = Number($routeParams.channel_id) || null;

        $scope.routeDate = Number($routeParams.date) || null;
      });

      $scope.$on('destroy', function () {
        if ($scope.watcher) $scope.watcher();
      })
    }]);
